export default "__VITE_ASSET__e45762ac__"